import { Component, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { Observable } from 'rxjs';
import { PASSWORD_REGEX } from 'src/app/ui/authentication/regex-policy';

import {
  AccountPasswordFacade,
  AccountPasswordViewModel,
} from './account-password.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-account-password',
  templateUrl: './account-password.component.html',
  styleUrls: ['./account-password.component.scss'],
  providers: [AccountPasswordFacade],
})
export class AccountPasswordComponent implements OnInit {
  form: FormGroup;
  accountStatus$: Observable<AccountPasswordViewModel>;

  constructor(private facade: AccountPasswordFacade) {
    this.accountStatus$ = this.facade.accountStatus$;
  }

  confirmPasswordValidator: ValidatorFn = (
    group: AbstractControl,
  ): ValidationErrors | null => {
    const pass = group.get('password')?.value;
    const confirmPass = group.get('passwordConfirmation')?.value;

    return pass == confirmPass ? null : { notSame: true };
  };

  ngOnInit(): void {
    this.form = new FormGroup(
      {
        oldPassword: new FormControl('', [Validators.required]),
        password: new FormControl('', [
          Validators.required,
          Validators.pattern(PASSWORD_REGEX),
        ]),
        passwordConfirmation: new FormControl('', [Validators.required]),
      },
      { validators: this.confirmPasswordValidator },
    );
  }

  get oldPasswordInvalid(): boolean | undefined {
    return (
      !this.form.get('oldPassword')?.valid &&
      (this.form.get('oldPassword')?.touched ||
        this.form.get('oldPassword')?.dirty)
    );
  }

  get passwordInvalid(): boolean | undefined {
    return (
      !this.form.get('password')?.valid &&
      (this.form.get('password')?.touched || this.form.get('password')?.dirty)
    );
  }

  get passwordConfirmationInvalid(): boolean | undefined {
    return (
      (!this.form.get('passwordConfirmation')?.valid ||
        this.form.hasError('notSame')) &&
      (this.form.get('passwordConfirmation')?.touched ||
        this.form.get('passwordConfirmation')?.dirty)
    );
  }

  submit() {
    if (this.form.valid) {
      this.facade.updatePassword(
        this.form.get('oldPassword')?.value,
        this.form.get('password')?.value,
      );
    }
  }
}
